var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"multicount"},_vm._l((_vm.list.map(function (ref) {
	var v = ref[1];

	return v;
})),function(c){return _c('div',{key:_vm.keyer(c.item),staticClass:"entry",class:c.count > 0 ? 'selected' : ''},[_c('span',{staticClass:"nom",on:{"click":function($event){return _vm.inc(c)}}},[_vm._v(_vm._s(_vm.view(c.item)))]),_c('span',{staticClass:"count",on:{"click":function($event){return _vm.dec(c)}}},[_vm._v(" "+_vm._s(c.count))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }